import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_media_filter_btn = _resolveComponent("media-filter-btn")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(_component_media_filter_btn, {
        icon: "fa fa-image",
        title: "Images",
        types: ['image'],
        "model-value": _ctx.modelValue,
        class: "q-py-sm",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }, null, 8, ["model-value"]),
      _createVNode(_component_media_filter_btn, {
        title: "Videos",
        icon: "fa fa-video",
        types: ['video', 'embed'],
        "model-value": _ctx.modelValue,
        class: "q-py-sm",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }, null, 8, ["model-value"]),
      (_ctx.modelValue.length)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            icon: "fa fa-times",
            class: "q-py-sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', [])))
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}